import React, { Component } from 'react';
import { connect } from "react-redux";
import {Link} from "react-router-dom";


@connect((store) => {
    return {
        chatprop: store.chatprop
    };
})
class Accordion extends Component {

    constructor(props) {
        super(props);
        this.handleOnClick=this.handleOnClick.bind(this);

        this.state={
            clicked:false
        }
    }

    componentWillMount() {
        if(typeof this.props.clicked!=="undefined"){
            this.setState({
               clicked:this.props.clicked
            });
        }
    }

    handleOnClick(){


        this.setState({
            clicked: !this.state.clicked
        });


    }

    render() {
        const { t } = this.props;
        var Components=()=>{
            return(
                ""
            );
        };
        if(typeof this.props.components!=="undefined"){
            var Components=this.props.components;
        }
        var icon="";
        if(typeof this.props.icon!=="undefined"){
            var icon=this.props.icon;
        }

        return (
            <React.Fragment>


                <div className="hv-accordion-container">
                    <Link to="" onClick={() => this.handleOnClick()} className={"accordion-link "+(this.state.clicked===true ? "menu-toggle": "")}>
                    <div className=" hv-accordion-inner settings-code-block-clean ">
                        <i className={"icon menuIcon  "+icon}></i>
                        <h6 className=" title">{this.props.title}</h6>
                    </div>
                    </Link>
                    {this.state.clicked === true &&
                        <div className="hv-accordion-container-component">
                            <Components operatorNotFoundMessage={this.props.operatorNotFoundMessage}
                                        queuedMessage={this.props.queuedMessage}
                                        setQueuedMessage={this.props.setQueuedMessage}
                                        setTopBar={this.props.setTopBar}
                                        setWelcomeMessage={this.props.setWelcomeMessage}
                                        setMessagePlaceholder={this.props.setMessagePlaceholder}
                                        topBar={this.props.topBar}
                                        welcomeMessage={this.props.welcomeMessage}
                                        messagePlaceholder={this.props.messagePlaceholder}
                                        setOperatorNotFoundMessage={this.props.setOperatorNotFoundMessage}/>
                        </div>
                    }
                </div>
            </React.Fragment>

        );
    }
}

export default Accordion;
